module.exports = __webpack_public_path__ + "img/6.b3f6e967.jpg";